export const formatTime = (date: Date): string => {
  return date.toLocaleTimeString('en-US', {
    localeMatcher: 'best fit',
    hour12: false,
    hour: 'numeric',
    minute: 'numeric',
  })
}

export const formatTimeShortDate = (date: Date): string => {
  return date.toLocaleString('en-US', {
    localeMatcher: 'best fit',
    hour12: false,
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  })
}

export const formatDate = (date: Date): string => {
  return date.toLocaleString('en-US', {
    localeMatcher: 'best fit',
    hour12: false,
    month: 'long',
    day: 'numeric',
  })
}

export const formatShortDate = (date: Date): string => {
  return date.toLocaleString('en-US', {
    localeMatcher: 'best fit',
    hour12: false,
    month: 'short',
    day: 'numeric',
  })
}

export const formatDateYear = (date: Date): string => {
  return date.toLocaleString('en-US', {
    localeMatcher: 'best fit',
    hour12: false,
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  })
}

export const formatShortDateYear = (date: Date): string => {
  return date.toLocaleString('en-US', {
    localeMatcher: 'best fit',
    hour12: false,
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
}

export const formatShortMonthYear = (date: Date): string => {
  // this is used for API requests only, and we need to use en-US here instead
  // of 'en-US', which would make it default to the user's locale
  return date.toLocaleString('en-US', {
    localeMatcher: 'best fit',
    hour12: false,
    month: 'short',
    year: 'numeric',
  })
}

export const formatMonthYear = (date: Date): string => {
  return date.toLocaleString('en-US', {
    localeMatcher: 'best fit',
    hour12: false,
    month: 'long',
    year: 'numeric',
  })
}
